var product = window.main_product || null;
var option_color_index = color_index;

var variantWithoutCompareAtPrice = sortVariants(getVariantWithoutCompareAtPrice(product.variants))

var variantsWithgetVariantWithCompareAtPrice = sortVariants(getVariantWithCompareAtPrice(product.variants));

var variantWithoutSalePriceRanges = getPriceRange(variantWithoutCompareAtPrice);

var variantWithSalePriceRanges = getPriceRange(variantsWithgetVariantWithCompareAtPrice);


function getVariantWithCompareAtPrice(variants) {
  return variants.filter(variant => variant.compare_at_price)
}

function getVariantWithoutCompareAtPrice(variants) {
  return variants.filter(variant => !variant.compare_at_price)
}

function getPriceRange(variants) {
  var prices = variants.map(variant => variant.price)
  
  return [...new Set(prices)];
}

function getColorValues(variants) {
  return variants.map(variant => variant.options[option_color_index])
}

function getVariantByColor(color) {
  return product.variants.filter(variant => variant.options[option_color_index] === color)
}

function sortVariants(variants) {
  return variants.sort((a, b) => parseFloat(b.price) - parseFloat(a.price));
}

function handleize(name) {
  return name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
}

function getCheckedOptionInputs() {
  return document.querySelectorAll('.swatch__options[data-variant-option] .swatch__option input:checked');
}

function getSelectedVariant() {
  var options = getCheckedOptionInputs();
  var colorInput = options[option_color_index];
  var sizeInput = options[window.size_index];

  if (!colorInput || !sizeInput || !product) return null;

  return product.variants.find(variant =>
    colorInput.value === variant.options[option_color_index] &&
    sizeInput.value === variant.options[window.size_index]
  ) || null;
}

function getVariantForColorPreview(color) {
  var sizeInput = getCheckedOptionInputs()[window.size_index];
  var colorVariants = getVariantByColor(color);

  if (!colorVariants.length) return null;

  if (sizeInput) {
    var match = colorVariants.find(variant => variant.options[window.size_index] === sizeInput.value);
    if (match) return match;
  }

  return colorVariants.find(variant => variant.available) || colorVariants[0] || null;
}

function updateLabel(e) {
  var $this = e;
  if (!$this) return;

  var parentEl = $this.closest('fieldset.swatch') || $this.parentNode.parentNode.parentNode.parentNode.parentNode;
  var label = parentEl && (
    parentEl.querySelector('.options-selection__option-name-varies') ||
    parentEl.querySelector('.options-selection__option-name')
  );

  if (label) {
    var span = label.querySelector('span');
    if (span) {
      span.innerHTML = $this.value;
    }
    window.selectedColorValue = $this.value;
  }
}

function updatePrice(variant) {
  if (!variant) return;

  var container = document.querySelector('[data-price-ui]');
  if (!container) return;

  var format = document.querySelector('body').dataset.moneyFormat;
  var tpl = `<span class="price {{saleClass}}" data-price>
			  <span class="money" data-price="">{{price}}</span>
			  </span>
			  {{priceRange}}
			  <span class="compare-at-price" data-compare-at-price {{hideIfPriceVaries}}>({{compare_at_price}})</span>
              <span class="unit-pricing" data-unit-pricing=""></span>`
  
  var onSale = variant.compare_at_price && variant.price < variant.compare_at_price,
      saleClass = onSale ? 'price--sale' : '',
      price = Shopify.formatMoney(variant.price, format),
      hideIfPriceVaries = !variant.compare_at_price ? 'style="display:none;"' : '',
      compare_at_price = variant.compare_at_price ? Shopify.formatMoney(variant.compare_at_price, format) : '',
      priceRangetpl = '';
  
  tpl = tpl.replace(/{{saleClass}}/g, saleClass);
  tpl = tpl.replace(/{{price}}/g, price);
  tpl = tpl.replace(/{{priceRange}}/g, priceRangetpl);
  tpl = tpl.replace(/{{hideIfPriceVaries}}/g, hideIfPriceVaries);
  tpl = tpl.replace(/{{compare_at_price}}/g, compare_at_price);
  
  container.innerHTML = tpl;
}

function updateOptionsByHover(e) {
  var $this = e;
  var size_index = window.size_index;
  var radio = isRadioInput($this) ? $this : $this.querySelector('input');
  var color = radio ? radio.value : null;

  if (!color) return;

  var variants = getVariantByColor(color);
  var previewVariant = getVariantForColorPreview(color);
  updatePrice(previewVariant);

  let size_options_el = document.querySelectorAll(`.swatch__options[data-variant-option-index="${size_index}"] .swatch__option input`);

  if (!variants.length) return;

  if (size_options_el.length === variants.length) {
    variants.forEach((variant) => {
      var handleize_size = handleize(variant.options[size_index]),
          selector = `.swatch--${handleize_size}`,
          size_input = document.querySelector(selector),
          available = variant.available;

      if (size_input) {
        size_input.dataset.variantOptionAvailable = available;
        size_input.disabled = !available;
      }
    });
  } else {
    size_options_el.forEach(input => {
      let val = input.value,
          variant = variants.find(variant => variant.options.includes(color) && variant.options.includes(val)) || null;

      if (variant) {
        input.dataset.variantOptionAvailable = variant.available;
        input.disabled = !variant.available;
      } else {
        input.dataset.variantOptionAvailable = false;
        input.disabled = true;
      }
    });
  }
}

function updateOptionsByMouseleave() {
  var options = getCheckedOptionInputs();
  var colorInput = options[option_color_index];

  if (colorInput) {
    updateLabel(colorInput);
    updateOptionsByHover(colorInput);
  }

  // Always restore the currently selected color + size price after hover preview
  updatePrice(getSelectedVariant());
}

var options = document.querySelectorAll('.js-variant-change')

options.forEach(option => {
  if (isRadioInput(option)) {
    var el = option;
  } else {
    var el = option.querySelector('input');
  }

  if (!el) return;

  if (el.checked) {
    var selectedOption = el;
  }

  el.addEventListener('change', function() {
    updateLabel(this);
    updatePrice(getSelectedVariant());
  });

  el.parentNode.addEventListener('mouseover', function() {
    updateOptionsByHover(this);
    updateLabel(el);
  });

  el.parentNode.addEventListener('mouseleave', function() {
    updateOptionsByMouseleave();
  });
})

function isRadioInput (element) {
  return element && element.getAttribute('type') === 'radio'
}
